export default __webpack_public_path__ + "static/media/FP_FR.a86b83dd.png";